import { styled, Typography } from "@mui/material";
import { ReactElement } from "react";

import theme, { palette } from "~frontend/theme";

import { ScriptPreview } from "./ScriptPreview";
import { CampaignForView } from "./types";

const VariantOverviewWrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1),
});

const VariantWrapper = styled("div")({
  backgroundColor: palette.lightGray,
  color: palette.darkGray,
  padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
});

export const VariantOverview = ({
  campaignId,
  scriptVariants,
  sampleContactData,
  scriptVariantsStartingIndex = 1,
  showFieldExplanation = true,
}: {
  campaignId: string;
  scriptVariants: CampaignForView["scriptVariants"];
  sampleContactData: Record<string, string>;
  scriptVariantsStartingIndex?: number;
  showFieldExplanation?: boolean;
}): ReactElement => {
  return (
    <VariantOverviewWrapper>
      {scriptVariants.map((variant, index) => (
        <VariantWrapper key={variant.id}>
          <Typography
            style={{
              textTransform: "uppercase",
              fontWeight: 600,
              fontSize: 12,
              letterSpacing: "0.48px",
            }}
          >
            Script{" "}
            {scriptVariants.length > 1 &&
              `Variant ${index + scriptVariantsStartingIndex}`}
          </Typography>

          <ScriptPreview
            campaignId={campaignId}
            variant={variant}
            sampleContactData={sampleContactData}
          />
        </VariantWrapper>
      ))}

      {showFieldExplanation && (
        <Typography variant="body2" color={palette.navy}>
          The script preview contact fields are based on the sample contact
          chosen in the Contact Upload step.
        </Typography>
      )}
    </VariantOverviewWrapper>
  );
};
